import * as css from 'css/exports.module.scss';
import './RecordRow.scss';
import { Row } from 'antd';
import { When } from 'react-if';
import React from 'react';
export const SonarRecordRow = ({ children, condition = true }) => React.createElement(When, { condition: condition },
    React.createElement(Row, { className: 'sonar-record-row', gutter: Number(css.size8), justify: 'space-between', wrap: false }, children));
